import { render } from "./ThankYouModal.vue?vue&type=template&id=00355736&scoped=true&ts=true&lang=pug"
import script from "./ThankYouModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThankYouModal.vue?vue&type=script&setup=true&lang=ts"

import "./ThankYouModal.vue?vue&type=style&index=0&id=00355736&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00355736"]])

export default __exports__